import { __module as e } from "../../../_virtual/isCurrency.js";
import { m as a } from "./util/merge.js";
import { a as t } from "./util/assertString.js";
!function (e, i) {
  Object.defineProperty(i, "__esModule", {
    value: !0
  }), i.default = function (e, a) {
    return (0, o.default)(e), function (e) {
      var a = "\\d{".concat(e.digits_after_decimal[0], "}");
      e.digits_after_decimal.forEach(function (e, t) {
        0 !== t && (a = "".concat(a, "|\\d{").concat(e, "}"));
      });
      var t = "(".concat(e.symbol.replace(/\W/, function (e) {
          return "\\".concat(e);
        }), ")").concat(e.require_symbol ? "" : "?"),
        i = "[1-9]\\d{0,2}(\\".concat(e.thousands_separator, "\\d{3})*"),
        r = "(".concat(["0", "[1-9]\\d*", i].join("|"), ")?"),
        o = "(\\".concat(e.decimal_separator, "(").concat(a, "))").concat(e.require_decimal ? "" : "?"),
        _ = r + (e.allow_decimal || e.require_decimal ? o : "");
      return e.allow_negatives && !e.parens_for_negatives && (e.negative_sign_after_digits ? _ += "-?" : e.negative_sign_before_digits && (_ = "-?" + _)), e.allow_negative_sign_placeholder ? _ = "( (?!\\-))?".concat(_) : e.allow_space_after_symbol ? _ = " ?".concat(_) : e.allow_space_after_digits && (_ += "( (?!$))?"), e.symbol_after_digits ? _ += t : _ = t + _, e.allow_negatives && (e.parens_for_negatives ? _ = "(\\(".concat(_, "\\)|").concat(_, ")") : e.negative_sign_before_digits || e.negative_sign_after_digits || (_ = "-?" + _)), new RegExp("^(?!-? )(?=.*\\d)".concat(_, "$"));
    }(a = (0, r.default)(a, s)).test(e);
  };
  var r = _(a),
    o = _(t);
  function _(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  var s = {
    symbol: "$",
    require_symbol: !1,
    allow_space_after_symbol: !1,
    symbol_after_digits: !1,
    allow_negatives: !0,
    parens_for_negatives: !1,
    negative_sign_before_digits: !1,
    negative_sign_after_digits: !1,
    allow_negative_sign_placeholder: !1,
    thousands_separator: ",",
    decimal_separator: ".",
    allow_decimal: !0,
    require_decimal: !1,
    digits_after_decimal: [2],
    allow_space_after_digits: !1
  };
  e.exports = i.default, e.exports.default = i.default;
}(e, e.exports);
var i = e.exports;
export { i };